import { sync } from 'vuex-router-sync'
import { store } from './store/store'
import VueRouter from 'vue-router'
import { routes } from './router/routes'

//import {mapGetters} from 'vuex'

import Vue from 'vue'
import App from './App.vue'

import VueI18n from 'vue-i18n'

import {mapGetters} from 'vuex'

import AxiosPlugin from './plugins/axios.js'
Vue.use(AxiosPlugin)

import Sweetalert2Plugin from './plugins/sweetalert2.js'
Vue.use(Sweetalert2Plugin)

import LodashPlugin from './plugins/lodash.js'
Vue.use(LodashPlugin)

//require('ie11-scroll-into-view');

const $ = require('jquery')
//import './assets/js/popper.js'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
//require('bootstrap')
//import 'bootstrap/dist/css/bootstrap.min.css'

//import './assets/js/popper.min.js'
import './assets/css/bootstrap.min.css'
//import './assets/js/bootstrap.min.js'


import './assets/css/bundle.css'
import './assets/css/plugins.css'
import './assets/css/style.css'
import './assets/css/responsive.css'
import './assets/css/custom.css'

import './assets/js/plugins.js'
/* import './assets/js/main.js'
import './assets/js/lightbox/js/lightbox.min.js' */


import './assets/css/v-custom.css'

var globalLocale = 'es'
if(process.env.NODE_ENV === 'development'){
  globalLocale = window.location.href.includes('/biv/en/') ? 'en' : 'es'
}else{
  globalLocale = window.location.href.includes('.com/en/') ? 'en' : 'es'
}

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: globalLocale,
  silentTranslationWarn: process.env.NODE_ENV === 'production',
  messages: {
    es:{
      "Catálogo de Productos - Grupo BIV":  "Catálogo de Productos - Grupo BIV",
      "Login - Grupo BIV": "Login - Grupo BIV",
      "Carrito - Grupo BIV": "Carrito - Grupo BIV",
      "Usuario - Grupo BIV": "Usuario - Grupo BIV",
      "Listas de favoritos - Grupo BIV":       "Listas de favoritos - Grupo BIV",
      "Pedidos - Grupo BIV": "Pedidos - Grupo BIV",
      "Perfil de Usuario - Grupo BIV": "Perfil de Usuario - Grupo BIV",
      "Cambiar Contraseña - Grupo BIV": "Cambiar Contraseña - Grupo BIV",
      "Ayuda - Grupo BIV": "Ayuda - Grupo BIV"
    },
    en: {
      "Catálogo de Productos - Grupo BIV": "Product catalog - BIV Group",
      "Login - Grupo BIV": "Login - BIV Group",
      "Carrito - Grupo BIV": "Shopping cart - BIV Group",
      "Usuario - Grupo BIV": "User - BIV Group",
      "Listas de favoritos - Grupo BIV": "Favourite lists - BIV Group",
      "Pedidos - Grupo BIV": "Orders - BIV Group",
      "Perfil de Usuario - Grupo BIV": "User profile - BIV Group",
      "Cambiar Contraseña - Grupo BIV": "Change password - BIV Group",
      "Ayuda - Grupo BIV": "Help - BIV Group"
    }
  }
});

Vue.use(VueRouter)
export const router = new VueRouter({
	/* mode: 'history', */
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 100, behavior: 'smooth' }
  },
  linkActiveClass: "active", // active class for non-exact links.
  linkExactActiveClass: "active" // active class for *exact* links.
});

router.beforeEach((to, from, next) => {
  let title;

  if ( to.meta.hasOwnProperty('breadcrumb') ) {
    for(let i=0; i<to.meta.breadcrumb.length; i++){
      if( i > 0){
        title = title + ' / ' + to.meta.breadcrumb[i].title;
      }else{
        title = to.meta.breadcrumb[i].title;
      }
    }
    document.title = i18n.t(title);
  }
  next()
})

sync(store, router);

Vue.directive('tooltip', {
  bind: function bsTooltipCreate(el, binding) {
    //console.log(binding)
    let trigger;
    if (binding.modifiers.focus || binding.modifiers.hover || binding.modifiers.click) {
      const t = [];
      if (binding.modifiers.focus) t.push('focus');
      if (binding.modifiers.hover) t.push('hover');
      if (binding.modifiers.click) t.push('click');
      trigger = t.join(' ');
    }
    $(el).tooltip({
      title: binding.value,
      placement: binding.arg,
      trigger: trigger,
      html: binding.modifiers.html
    });
  },
  update: function bsTooltipUpdate(el, binding) {
    const $el = $(el);
    $el.attr('title', binding.value).tooltip('_fixTitle');

    const data = $el.data('bs.tooltip');
    if (binding.modifiers.live) { // update live without flickering (but it doesn't reposition)
      if (data.$tip) {
        if (data.options.html) data.$tip.find('.tooltip-inner').html(binding.value);
        else data.$tip.find('.tooltip-inner').text(binding.value);
      }
    } else {
      if (data.inState.hover || data.inState.focus || data.inState.click) $el.tooltip('show');
    }
  },
  unbind(el, binding) {
    $(el).tooltip('dispose');
  },
});

var app = new Vue({
  el: '#app',
  i18n,
  store,
  router,
  render: h => h(App)
})


import Searchbox from './Searchbox.vue'

var searchbox = new Vue({
  el: '#searchbox',
  i18n,
  store,
  router,
  render: h => h(Searchbox)
})


import Shopmenu from './Shopmenu.vue'

var shopmenu = new Vue({
  el: '#shopmenu',
  i18n,
  store,
  router,
  render: h => h(Shopmenu)
})


import Productslink from './Productslink.vue'

var productslink = new Vue({
  el: '#productslink',
  i18n,
  store,
  router,
  computed: mapGetters(['getLocale']),
  watch: {
    '$route' (to, from){
      this.$i18n.locale = this.getLocale
    }
  },
  render: h => h(Productslink)
})

if(process.env.NODE_ENV === 'development'){
  i18n.locale = store.getters.getLocale
}else{
  let globalLocale = window.location.href.includes('.com/en/') ? 'en' : 'es'
  store.commit('mutateLocale', globalLocale)
  i18n.locale = globalLocale
}